module.exports = "https://static.wmbcdn.com/uniweb/images/d978ff7b78e31ed6d363514b9122723c.svg";